export default __webpack_public_path__ + "img/cadooz_footer_logo.17604953.svg";